import { render, staticRenderFns } from "./Alarms.vue?vue&type=template&id=e5201ed2&scoped=true"
import script from "./Alarms.vue?vue&type=script&lang=js"
export * from "./Alarms.vue?vue&type=script&lang=js"
import style0 from "./Alarms.vue?vue&type=style&index=0&id=e5201ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5201ed2",
  null
  
)

export default component.exports